module.exports = "https://la-static.vkplay.ru/promo/universal/img/separator.ddb9dcda.svg";